import { css } from "@stubhub/broadway-foundation/css";

export const COMPONENT_CSS_VAR_NAMES = {
  iconColor: "--component-icon-color",
} as const satisfies Record<string, `--component-${string}`>;

export const spacer = css({
  marginInlineStart: "primitives.200",
});

export const card = css({
  width: "[64px]",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  overflowX: "hidden",
  overflowY: "hidden",
  textTransform: "uppercase",
  color: "var(--component-icon-color)",
});
export const replacementIcon = css({
  marginBlock: "primitives.150",
  marginInline: "primitives.150",
});

export const dateContainer = css({
  width: "full",
  paddingInline: "primitives.25",
  paddingBlockStart: "primitives.25",
  paddingBlockEnd: "primitives.50",
  color: "text",
});

export const pendingText = css({
  marginBlock: "primitives.100",
});

export const strikeThroughText = css({
  textDecorationLine: "line-through",
});

export const subtleText = css({
  color: "text.subtle",
});
export const brandText = css({
  color: "text.brand",
});
export const disabledText = css({
  color: "text.disabled",
});

export const countdownChip = css({
  width: "[64px]",
  marginBlockStart: "primitives.100",
  textAlign: "center",
  borderStartStartRadius: "element.extraSmall",
  borderStartEndRadius: "element.extraSmall",
  borderEndStartRadius: "element.extraSmall",
  borderEndEndRadius: "element.extraSmall",
  overflowX: "hidden",
  overflowY: "hidden",
});

export const countdownChipActive = css({
  marginBlockStart: "primitives.50",
  paddingBlock: "primitives.25",
  paddingInline: "primitives.50",
  backgroundColor: "bg.fill.accent",
});

export const countdownChipActiveText = css({
  color: "text.onFill.accent",
});

export const timeTbaText = css({
  marginInlineStart: "primitives.50",
});
